import React from 'react';
import TextInput from '../../../Shared/TextInput/TextInput';
import {ID_NUMBER_TYPE_OPTIONS} from '../../../../utilities/validation/idNumberValidation';

const IdDetailsSection = ({form, formErrors, onFieldChange}) => (
  <div className='activate-niud-sub-step'>
    <div className='M_Sub_Title'>פרטי זיהוי</div>
    <div className='activate-niud-field'>
      <TextInput
        error={formErrors.idNumberType}
        onChange={(e) => onFieldChange('idNumberType', e.target.value)}
        type='select'
        placeholder='סוג מזהה'
        name='idNumberType'
        value={form.idNumberType}
        required='required'>
        <option key='choose' value=''>
          בחר
        </option>
        {ID_NUMBER_TYPE_OPTIONS.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </TextInput>
    </div>
    <div className='activate-niud-field'>
      <TextInput
        error={formErrors.idNumber}
        onChange={(e) => onFieldChange('idNumber', e.target.value)}
        placeholder='מספר מזהה'
        name='idNumber'
        value={form.idNumber}
        type='text'
        required='required'
      />
    </div>
  </div>
);

export default IdDetailsSection;
